import { BuildingId, UpgradeId } from '../types'

export const GameEvents = {
  CLICK: 'game:click',
  BUILDING_PURCHASE: 'game:building:purchase',
  UPGRADE_PURCHASE: 'game:upgrade:purchase',
  RESET: 'game:reset',
} as const

export type GameEventPayloads = {
  [GameEvents.CLICK]: void
  [GameEvents.BUILDING_PURCHASE]: { readonly buildingId: BuildingId }
  [GameEvents.UPGRADE_PURCHASE]: { readonly upgradeId: UpgradeId }
  [GameEvents.RESET]: void
}
